export default "__VITE_ASSET__CX2wa_xd__"